import { Foodstuff } from "../../models/Foodstuff"
import { Meal } from "../../models/Meal"
import { LanguageCode } from "./Language"


export function stringToLanguageCode(str: string): LanguageCode | undefined {
  switch (str) {
    case 'EN':
      return LanguageCode.EN
    case 'CS':
      return LanguageCode.CS
    case 'SK':
      return LanguageCode.SK
    default:
      return undefined
  }
}

export function mealLanguageCodeToGlobal(lang: Meal.languageCode): LanguageCode {
  return LanguageCode[lang as keyof typeof LanguageCode]
}

export function globalLanguageCodeToMeal(lang: LanguageCode): Meal.languageCode {
  return lang as unknown as Meal.languageCode
}

export function stringsToLanguageCodes(strs: string[]): LanguageCode[] {
  return strs
    .map(str => stringToLanguageCode(str))
    .filter((lang): lang is LanguageCode => lang !== undefined)
}

export function mealLanguageCodesToGlobal(langs: Meal.languageCode[]): LanguageCode[] {
  return langs.map(lang => mealLanguageCodeToGlobal(lang))
}

export function stringToFoodstuffLanguageCode(str: string): Foodstuff.languageCode | undefined {
  switch (str) {
    case 'EN':
      return Foodstuff.languageCode.EN;
    case 'CS':
      return Foodstuff.languageCode.CS;
    case 'SK':
      return Foodstuff.languageCode.SK;
    default:
      return undefined;
  }
}

export function globalLanguageCodeToFoodstuff(lang: LanguageCode): Foodstuff.languageCode {
  return lang as unknown as Foodstuff.languageCode;
}